// @flow
import WidgetLoader from './WidgetLoader'
export default WidgetLoader
